import React, { useContext } from "react";
import { IntlContext } from "context";
import { ShieldCheck } from "lucide-react";

const OfferSecurityNotice: React.FC = () => {
    const intl = useContext(IntlContext);

    return (
        <section className="rounded-xl border border-amber-100 bg-amber-50/50 px-4 py-4">
            <div className="flex gap-3">
                <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" aria-hidden="true" />
                <div>
                    <h3 className="text-xs font-medium leading-5 text-amber-900">
                        {intl.formatMessage("booking.messages.offer.security.title")}
                    </h3>
                    <p className="text-xs font-normal leading-5 text-amber-800">
                        {intl.formatMessage("booking.messages.offer.security.description")}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default OfferSecurityNotice;
